// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"515":"42adc7b0","791":"fc55d7ce"}[chunkId] + ".chunk.css";
};